import { Link } from "gatsby"
import React, { memo } from "react"
import SVGIcon from "./common/SVGIcon"
import CheckLinkDomain from "./utility/current_domain"

const NavbarDropdownMobile = props => {
  const { navigationLinks } = props.data

  const setPageId = childFooterLink => {
    if (childFooterLink) {
      console.log("childFooterLink ", childFooterLink)
      sessionStorage.setItem("SuperPageSectionID", childFooterLink)
    }
  }

  const Products = memo(() => {
    const data = navigationLinks.slice(0, 3)
    const AllIntegrations = navigationLinks?.filter(
      _ => _?.heading === "SEE ALL INTEGRATIONS"
    )
    return (
      <div className="navbar-products-wrapper mb50">
        {data?.map((item, idx) => {
          return (
            <>
              <div
                className={`bar d-flex align-items-center justify-content-between mb32 mt40`}
              >
                <p className={`p-14 fw-800 font-zodiak text-deep-purple `}>
                  {item?.heading}
                </p>
                <div className="hor-line"></div>
              </div>
              {item?.featureNavigationLinks?.map(element => {
                return (
                  <>
                    {element?.link ? (
                      <Link
                        to={element?.link}
                        target={
                          CheckLinkDomain(element?.link) ? "_self" : "_blank"
                        }
                        className="d-flex gap-24 align-items-center mb14 mt32 feature-heading"
                      >
                        <p className="fw-800 p-14 font-zodiak m-0 text-deep-purple">
                          {element?.heading}
                        </p>
                        <SVGIcon
                          name="hypertext-arrow-right"
                          className="arrow-right"
                        />
                      </Link>
                    ) : (
                      <div className="d-flex gap-24 align-items-center mb14 mt32 feature-heading">
                        <p className="fw-800 p-14 font-zodiak m-0 text-deep-purple">
                          {element?.heading}
                        </p>
                      </div>
                    )}

                    {element?.featureNavigationLinks?.map(features => {
                      return (
                        <Link
                          to={features?.link}
                          target={
                            CheckLinkDomain(features?.link) ? "_self" : "_blank"
                          }
                          onClick={() => setPageId(features?.childFooterLink)}
                        >
                          <div className="d-flex align-items-center gap-6 icon-text text-deep-purple position-relative mb2">
                            <div className="icon-wrapper">
                              <img
                                className="icon w-100"
                                src={features?.icon?.url}
                                alt="icon"
                              />
                            </div>

                            <p className="p13 m-0">{features?.heading}</p>
                            {features?.isNew === "Yes" && (
                              <p className="tag position-absolute m-0">NEW</p>
                            )}
                          </div>{" "}
                        </Link>
                      )
                    })}
                  </>
                )
              })}
              {item?.heading === "Integrations" && (
                <div className="all-integration mt24">
                  <Link
                    to={AllIntegrations?.[0]?.link}
                    className="d-flex flex-column h-100 justify-content-between"
                  >
                    <img src={AllIntegrations?.[0]?.image?.url} className="w-100" />
                    <p className="p13 word w-100 m-0 text-center">
                      {AllIntegrations?.[0]?.heading}
                    </p>
                  </Link>
                </div>
              )}
            </>
          )
        })}

      </div>
    )
  })

  const Resources = memo(() => {
    const LeftBar = navigationLinks?.slice(0, -1)
    return (
      <div className="navbar-resources-wrapper mb50">
        {LeftBar?.map((item, idx) => {
          return (
            <>
              <div className={`bar`}>
                <p
                  className={`mt32 mb14 p-14 fw-800 font-zodiak text-deep-purple ${item?.heading === "NO HEADING" ? "dspnone" : ""
                    }`}
                >
                  {item?.heading}
                </p>
              </div>
              {item?.featureNavigationLinks?.map(features => {
                return (
                  <>
                    <Link
                      to={features?.link}
                      target={
                        CheckLinkDomain(features?.link) ? "_self" : "_blank"
                      }
                    >
                      <div className="d-flex align-items-center gap-6 icon-text text-deep-purple position-relative mb2">
                        <div className="icon-wrapper">
                          <img
                            className="icon w-100"
                            src={features?.icon?.url}
                            alt="icon"
                          />
                        </div>

                        <p className="p13 m-0 text-deep-purple">
                          {features?.heading}
                        </p>
                        {features?.isNew === "Yes" && (
                          <p className="tag position-absolute m-0">NEW</p>
                        )}
                      </div>{" "}
                    </Link>
                  </>
                )
              })}
            </>
          )
        })}
      </div>
    )
  })

  const Marketplace = memo(() => {
    const LeftBar = navigationLinks?.slice(0, -1)
    return (
      <div className="navbar-marketplace-wrapper mb50">
        {LeftBar?.map((item, idx) => {
          if (LeftBar?.length - 1 > idx)
            return (
              <>
                <div className={`bar`}>
                  <p
                    className={`mt32 mb14 p-14 fw-800 font-zodiak text-deep-purple ${item?.heading === "NO HEADING" ? "dspnone" : ""
                      }`}
                  >
                    {item?.heading}
                  </p>
                </div>
                {item?.featureNavigationLinks?.map(features => {
                  return (
                    <>
                      <Link
                        to={features?.link}
                        target={
                          CheckLinkDomain(features?.link) ? "_self" : "_blank"
                        }
                      >
                        <div className="d-flex align-items-center gap-6 icon-text text-deep-purple position-relative mb2">
                          <div className="icon-wrapper">
                            <img
                              className="icon w-100"
                              src={features?.icon?.url}
                              alt="icon"
                            />
                          </div>

                          <p className="p13 m-0 text-deep-purple">
                            {features?.heading}
                          </p>
                          {features?.isNew === "Yes" && (
                            <p className="tag position-absolute m-0">NEW</p>
                          )}
                        </div>{" "}
                      </Link>
                    </>
                  )
                })}
              </>
            )
          else {
            return (
              <div className="all-integration mt24">
                <Link
                  to={item?.link}
                  className="d-flex flex-column h-100 justify-content-between"
                >
                  <img src={item?.image?.url} className="w-100" />
                  <p className="p13 word w-100 m-0 text-center">
                    {item?.heading}
                  </p>
                </Link>
              </div>
            )
          }
        })}
      </div>
    )
  })

  switch (props.data.name) {
    case "Why SuperOps": {
      return (
        <div className="navbar-why-superops-wrapper mb50">
          <p className="p20 fw-800 font-zodiak text-center mt40 mb30 text-deep-purple">
            {props?.data?.where}
          </p>
          <div className="d-flex gap-24 justity-content-between flex-wrap">
            {navigationLinks?.map(item => {
              if (item?.link) {
                return (
                  <div className="box dynamic">
                    <Link
                      to={item?.link}
                      className="h-100 d-flex justify-content-between flex-column"
                    >
                      <div className="top">
                        <div
                          className="icon-wrapper mb30 br10"
                          // css={css`
                          //   background: linear-gradient(
                          //     90deg,
                          //     ${item?.iconBgColor?.css} -9.17%,
                          //     rgba(255, 255, 255, 0) 100%
                          //   );
                          // `}
                        >
                          <img
                            className="icon w-100"
                            src={item?.icon?.url}
                            alt="icon"
                          />
                        </div>
                        <p className="p15 fw-800 mb14 font-zodiak text-deep-purple">
                          {item?.heading}
                        </p>
                        <p className="p11 m-0 text-deep-purple">
                          {item?.childFooter}
                        </p>
                      </div>
                      <div className="bottom">
                        <p className="p10 m-0 text-center text-deep-purple">
                          {item?.subText}
                        </p>
                      </div>
                    </Link>
                  </div>
                )
              } else {
                return (
                  <div className="box constant prelative">
                    <div className="white-bg">
                      <div className="image-wrapper mb16 mx-auto">
                        <img src={item?.image?.url} className="w-100" />
                      </div>
                      <p className="p-13-20 fw-800 font-zodiak m-0 text-center text-deep-purple">
                        {item?.heading}
                      </p>
                      <p className="p-13-20 fw-800 font-zodiak pink-yellow-gradient m-0 text-center">
                        {item?.subText}
                      </p>
                    </div>
                    <div className="position-absolute bg-color-card"></div>
                  </div>
                )
              }
            })}
          </div>
        </div>
      )
    }
    case "Products": {
      return <Products />
    }
    case "Resources":
      return <Resources />
    case "Pricing": {
      return (
        <div className="pricing-drpdown mt32 mb50 d-flex flex-column gap-12">
          {navigationLinks.map(item => {
            return (
              <Link to={item.link}>
                <p className="p-14 fw-500 icon-text text-deep-purple">
                  {item.heading}
                </p>
              </Link>
            )
          })}
        </div>
      )
    }
    case "Solutions": {
      return (
        <div className="solutions-drpdown mt32 mb50">
          {navigationLinks.map(item => {
            return (
              <Link to={item?.link}>
                <div className="icon-text mb16">
                  <div className="position-relative">
                    <p className="title fw-800 font-zodiak">{item?.heading}</p>
                    <p className="subtext text-deep-purple">{item?.subText}</p>
                  </div>
                </div>
              </Link>
            )
          })}
        </div>
      )
    }
    case "Marketplace": {
      return <Marketplace />
    }
    default: {
      return <></>
    }
  }
}

export default memo(NavbarDropdownMobile)
